import { API_URL } from '../../../app-config/constants';
import { get, post } from '../request';

export interface ObjectiveCoachStatus {
    id: string; // objective id
    dismissedAt: number;
    feedback?: ObjectiveCoachFeedback;
}

interface ObjectiveCoachFeedback {
    helpful: boolean;
    createdAt: number;
}

getObjectiveCoachStatus.operation = 'READ';
export function getObjectiveCoachStatus(id: string): Promise<ObjectiveCoachStatus> {
    return get(`${API_URL}/objective-coach/${id}/status`);
}

hide.operation = 'COMMAND';
export function hide(objectiveId: string): Promise<ObjectiveCoachStatus> {
    return post(`${API_URL}/objective-coach/${objectiveId}/hide`);
}

unhide.operation = 'COMMAND';
export function unhide(objectiveId: string): Promise<ObjectiveCoachStatus> {
    return post(`${API_URL}/objective-coach/${objectiveId}/unhide`);
}

sendFeedback.operation = 'COMMAND';
export function sendFeedback(objectiveId: string, helpful: boolean): Promise<ObjectiveCoachStatus> {
    return post(`${API_URL}/objective-coach/${objectiveId}/feedback`, { postData: { helpful } });
}
